import React, { useState } from 'react'
import { useMakeSelector } from 'hooks/redux'
import { makeComponentMetaSelector } from 'selectors/navigator'
import { setSelectedIdWithDrawer, removeComponentMeta } from 'actions/navigator'
import {
  DRAWER_SELECT_MODE,
  DRAWER_APPLY_CUSTOM_TEMPLATE,
  DRAWER_APPLY_DAIMLER_TEMPLATE,
  DRAWER_SAVE_TEMPLATE,
} from 'constants/ui/ptoDiagram'
import strings from 'utils/strings'
import { useDispatch } from 'react-redux'
import { StyledAlert, PtoTemplateContainer } from '../PowerTakeOff.style'

import SelectPtoTemplateMode from '../SelectPtoTemplateMode'
import ApplyTemplate from '../ApplyTemplate'
import CreateTemplate from '../CreateTemplate'
import { StyledDrawerTitle } from './TemplateDrawerWrapper.style'

const TemplateDrawerWrapper = () => {
  const dispatch = useDispatch()
  const { serialNumber } = useMakeSelector(makeComponentMetaSelector, {
    id: 'ptoTemplatesWrapper',
  })
  const [drawerState, setDrawerState] = useState(DRAWER_SELECT_MODE)
  const [drawerTitle, setDrawerTitle] = useState(
    strings.apply_pto_template_action_bar
  )

  const onClose = () => {
    dispatch(removeComponentMeta(['ptoTemplatesWrapper']))
    dispatch(setSelectedIdWithDrawer(null))
  }

  return (
    <PtoTemplateContainer>
      <div>
        <StyledAlert
          type="info"
          persistent
          icon="edit"
          showIcon={false}
          actionTrigger={{
            onClick: onClose,
            text: strings.exit_pto_templates,
          }}
          message={`${strings.pto_template} ${serialNumber}`}
        />
        <StyledDrawerTitle data-testid="drawer-title">
          {drawerTitle}
        </StyledDrawerTitle>
      </div>
      <>
        {drawerState === DRAWER_SELECT_MODE && (
          <SelectPtoTemplateMode
            setDrawerTitle={setDrawerTitle}
            setDrawerState={setDrawerState}
            serialNumber={serialNumber}
            onClose={onClose}
            isDrawerVisible
          />
        )}

        {drawerState === DRAWER_APPLY_CUSTOM_TEMPLATE && (
          <ApplyTemplate
            setDrawerTitle={setDrawerTitle}
            setDrawerState={setDrawerState}
            serialNumber={serialNumber}
            toggleTemplateDrawer={onClose}
            isDrawerVisible
            templateType="custom"
          />
        )}

        {drawerState === DRAWER_APPLY_DAIMLER_TEMPLATE && (
          <ApplyTemplate
            setDrawerTitle={setDrawerTitle}
            setDrawerState={setDrawerState}
            serialNumber={serialNumber}
            toggleTemplateDrawer={onClose}
            isDrawerVisible
            templateType="daimler"
          />
        )}

        {drawerState === DRAWER_SAVE_TEMPLATE && (
          <CreateTemplate
            setDrawerTitle={setDrawerTitle}
            setDrawerState={setDrawerState}
            serialNumber={serialNumber}
            toggleTemplateDrawer={onClose}
            isDrawerVisible
            templateType="daimler"
          />
        )}
      </>
    </PtoTemplateContainer>
  )
}

export default TemplateDrawerWrapper
